import { withCloseAfterExited } from "@10duke/dukeui";
import {
  default as View,
  RemoveDeviceClientModalProps
} from "./remove-device-client-modal-view";

const RemoveDeviceClientModal = withCloseAfterExited<RemoveDeviceClientModalProps>(View);
export default RemoveDeviceClientModal;
